import styled from '@emotion/styled/macro';

import { getFont } from '@styles/mixins/fonts';

interface CopyrightProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {}

export const Copyright: React.FC<CopyrightProps> = ({ className }) => {
  return (
    <HomeLink className={className} href="https://excorp.gg/">
      powered by <CompanyName>excorp.gg</CompanyName>
    </HomeLink>
  );
};

const CompanyName = styled.span`
  color: var(--colors-green);
  transition: opacity var(--duration-base) linear;
`;

const HomeLink = styled.a`
  ${getFont('copyright')}
  text-align: center;

  &:hover ${CompanyName} {
    opacity: 0.2;
  }
`;
